import { array, boolean, object, schema, string } from "@anna-money/anna-web-lib/serializer";

export enum PoaRejectResult {
  ForgeryCheckFailed = "forgery_check_failed",
  UnknownDocumentType = "unknown_document_type",
  DocumentOutOfDate = "document_out_of_date",
  NameMismatch = "name_mismatch",
}

export class PoaAddressData extends schema(
  {
    country: string().optional(),
    city: string().optional(),
    street: string().optional(),
    postcode: string().optional(),
    buildingNumber: string().optional(),
    flatNumber: string().optional(),
  },
  "PoaAddressData",
) {}

export enum AustralianCounty {
  AustralianCapitalTerritory = "Australian Capital Territory",
  NewSouthWales = "New South Wales",
  NorthernTerritory = "Northern Territory",
  Queensland = "Queensland",
  SouthAustralia = "South Australia",
  Tasmania = "Tasmania",
  Victoria = "Victoria",
  WesternAustralia = "Western Australia",
  CocosIslands = "Cocos (Keeling) Islands",
  ChristmasIsland = "Christmas Island",
  JervisBayTerritory = "Jervis Bay Territory",
  NorfolkIsland = "Norfolk Island",
}

export class AddressData extends schema(
  {
    id: string(),
    created: string(),
    updated: string(),
    premise: string(),
    street: string(),
    town: string(),
    country: string(),
    postcode: string(),
    externalAddressId: string().optional(),
    companyId: string().optional(),
    directorIdRegistered: string().optional(),
    directorIdService: string().optional(),
    // AU
    businessCompanyId: string().optional(),
    // county: _enum(Object.values(AustralianCounty) as AustralianCounty[], "AustralianCounty").nullable(),
    county: string().optional(),
    isOwnedByCompany: boolean().optional(),
    occupierName: string().optional(),
    occupierDeclaration: boolean().optional(),
    isUsualResidentalAddress: boolean().optional(),
    asicApprovalNumber: string().optional(),
    // POA verification fields
    isPoaPassedChecks: boolean().optional(),
    poaRejectResult: string().optional(),
    poaFileId: string().optional(),
    poaAddress: object(PoaAddressData).optional(),
  },
  "AddressData",
) {}

export class AddressListData extends schema(
  {
    addresses: array(object(AddressData)),
  },
  "AddressListDataSchema",
) {}

export class AddressCreateData extends schema(
  {
    premise: string().optional(),
    street: string().optional(),
    town: string(),
    postcode: string(),
    externalAddressId: string().optional(),
    // AU
    county: string().optional(),
    isOwnedByCompany: boolean().optional(),
    occupierName: string().optional(),
    occupierDeclaration: boolean().optional(),
    isUsualResidentalAddress: boolean().optional(),
    asicApprovalNumber: string().optional(),
    country: string().optional(), // For non-AU addresses
    //
    companyId: string().optional(),
    directorIdRegistered: string().optional(),
    directorIdRegisteredPrevious: string().optional(),
    companyActivityId: string().optional(),
    businessCompanyId: string().optional(),
  },
  "AddressCreateDataSchema",
) {}

export class AddressUpdateData extends schema(
  {
    premise: string().optional(),
    street: string().optional(),
    town: string(),
    postcode: string(),
    externalAddressId: string().optional(),
    // AU
    county: string().optional(),
    isOwnedByCompany: boolean().optional(),
    occupierName: string().optional(),
    occupierDeclaration: boolean().optional(),
    isUsualResidentalAddress: boolean().optional(),
    asicApprovalNumber: string().optional(),
    country: string().optional(),
    poaFileId: string().optional(),
  },
  "AddressUpdateDataSchema",
) {}
